import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_f0W2DVjINO3H: {
	id: 'prd_f0W2D2DEV2VjINO3H'
	ident: 'prd_f0W2DVjINO3H'
	sku: 'simple_premium_4w_11_99_4w_52_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: 1
			price_id: 'prc_ox8M92DEV2HbNGTkl'
			amount: 52
			amount_usd: 11.99
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 11.99
			discount: 40.01
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: null
			price_id: 'prc_xbnwO2DEV2ATnojBi'
			amount: 52
			amount_usd: 52
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_f0W2DVjINO3H, SubscriptionProduct>
const prd_f0W2DVjINO3H = { ident: 'prd_f0W2DVjINO3H' } as typeof _prd_f0W2DVjINO3H

export default prd_f0W2DVjINO3H
